export default function FilmGrain() {
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 z-[999] opacity-[0.06] mix-blend-overlay bg-grain"
    />
  );
}
